import React, { Component, PropTypes } from 'react';
import { Link, withRouter } from 'react-router';

const AccountRemoved = () => (
  <div className="l-content info-screen" id="content">
    <header>
      <h2>Bummer...</h2>
    </header>

    <div className="row">
      <div className="columns medium-8 small-16">

        <h2>Account Deleted</h2>

        <p>
          We're sad that you've decided to leave our community, but we've enjoyed
          working with you. If there's anything else we can do for you, please
          don't hesitate to reach out. Our <a>customer service team</a> will be
          happy to help.
        </p>

      </div>

      <div className="columns medium-8 small-16 icon hide-for-small-only">
        <i className="fa fa-frown-o"></i>
      </div>
    </div>

  </div>
)

export default AccountRemoved;



// WEBPACK FOOTER //
// ./account/components/account_removed.jsx